import styled from 'styled-components';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

const Image = styled.img`
    width: 100px;
    height: 100px;
    display: block;
    
    position: relative;
    
    ${mediaWidth.m} {
        width: 108px;
        height: 108px;
    }
    ${mediaWidth.l} {
        width: 129px;
        height: 129px;
    }
    ${mediaWidth.xl} {
        width: 187px;
        height: 187px;
    }
`;

export default Image;
